import { render, staticRenderFns } from "./zknum.vue?vue&type=template&id=771e4bc6&scoped=true"
import script from "./zknum.vue?vue&type=script&lang=js"
export * from "./zknum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e4bc6",
  null
  
)

export default component.exports